import React from 'react'
import { useAccountContext } from '@features/account/contexts/core'
import { Loading } from '@components/ui/Loading/Loading'
import { IOwner } from '@features/account/types'
import ProfileAvatar from './ProfileAvatar/ProfileAvatar'
import ProfilePasswordBox from './ProfilePasswordBox/ProfilePasswordBox'
import ProfileInfoBox from './ProfileInfoBox/ProfileInfoBox'
import './MkProfile.scss'

interface MkProfileProps {
  owner: IOwner
}

const MkProfile: React.FC<MkProfileProps> = ({ owner }) => {
  const { profileLoading } = useAccountContext()

  return (
    <div className="mk-profile">
      {profileLoading ? (
        <Loading />
      ) : (
        <div className="mk-profile__grid">
          {/* Left Column - 1/3 width */}
          <div className="mk-profile__left">
            {/* User Avatar Box */}
            <ProfileAvatar name={owner.name || ''} />

            {/* Password Management Box */}
            <ProfilePasswordBox owner={owner} />
          </div>

          {/* Right Column - 2/3 width */}
          <div className="mk-profile__right">
            <ProfileInfoBox owner={owner} />
          </div>
        </div>
      )}
    </div>
  )
}

export default MkProfile
